// extracted by mini-css-extract-plugin
export default {"mainContain":"About_mainContain__Crfq8","left_panel":"About_left_panel__gYI6a"};